module.exports = __webpack_public_path__ + "static/media/g.dd32c231.svg";